module.exports = __webpack_public_path__ + "static/media/Artboard20.47d73f6b.png";